define('presentation/welcome/viewModels/onboardingWelcomeViewModel',[
    'common/promises/promiseFactory',
    'constants/signupOnboardingSelectionConstants',
    'presentation/welcome/common/onboardingNavigationManager',
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _i18n = require('i18next');
        const _signupOnboardingSelectionConstants = require('constants/signupOnboardingSelectionConstants');

        let _onboardingNavigationManager = null;
        let _isNavigating = false;

        self.isCompositionComplete = ko.observable(false);
        self.isMinContentContainer = true;
        self.headingText = _i18n.t('onboardingWelcome:headerTitle');
        self.subtitleText = '';
        self.selectedOnboardingOption = ko.observable(_signupOnboardingSelectionConstants.configureOnline);

        const _buildOnboardingOption = (optionId, i18nKeyPrefix) => {
            return {
                title: _i18n.t(`onboardingWelcome:${i18nKeyPrefix}Title`),
                description: _i18n.t(`onboardingWelcome:${i18nKeyPrefix}Description`),
                isSelected: ko.pureComputed(() => self.selectedOnboardingOption() === optionId),
                onClick: () => self.selectedOnboardingOption(optionId)
            };
        };

        self.onboardingOptions = [
            _buildOnboardingOption(_signupOnboardingSelectionConstants.configureOnline, 'onboardingOptionOnline'),
            _buildOnboardingOption(_signupOnboardingSelectionConstants.onboardingCall, 'onboardingOptionCall')
        ];

        self.isSchedulingSelected = ko.pureComputed(() => {
            return self.selectedOnboardingOption() !== _signupOnboardingSelectionConstants.configureOnline;
        });

        self.continueButtonText = ko.pureComputed(() => {
            return self.isSchedulingSelected() ?
                _i18n.t('onboardingWelcome:scheduleOnboarding') :
                _i18n.t('onboardingWelcome:startOnboarding');
        });

        self.onContinue = () => {
            return _promiseFactory.deferWithMinimumWait((promise) => {
                if (_isNavigating) {
                    promise.resolve({keepSpinning: true});
                    return;
                }
                _isNavigating = true;

                if (self.isSchedulingSelected()) {
                    _onboardingNavigationManager.navigateToSchedulingPage();
                } else {
                    _onboardingNavigationManager.navigateToFlowStartPage();
                }

                promise.resolve({keepSpinning: true});
            });
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const OnboardingNavigationManagerConstructor = require('presentation/welcome/common/onboardingNavigationManager');
            _onboardingNavigationManager = new OnboardingNavigationManagerConstructor();
            _onboardingNavigationManager.init();

            return _initialize();
        };

        const _initialize = () => {
            return _promiseFactory.wait();
        };
    };
});
